import { FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Grid } from '@material-ui/core'
import { AddressReverseResult } from 'src/dataSources/dataforsyningen/AddressReverse'
import { NearestBoreholeObject } from 'src/dataSources/geo/NearestBoreHoles'
import { boreholeMetaStyle } from './BoreholeMeta.style'
import { useSelector } from 'react-redux'
import { RootState } from 'src/Store'
import { DataList, BoreholeSource } from 'src/dataSources/geo/DataList'
/**
 * BoreholeMetaProps contains properties for the component.
 */
export interface BoreholeMetaProps {
  selectedBorehole: NearestBoreholeObject | undefined
  postalAddress?: AddressReverseResult
}

/**
 * BoreholeMeta displays meta information for boreholes.
 * @param props Properties for component.
 * @returns JSX component.
 */
export const BoreholeMeta: FC<BoreholeMetaProps> = (props: BoreholeMetaProps) => {
  const classes = boreholeMetaStyle()
  const tokenSelector = useSelector((state: RootState) => state.authState.token)

  const [dataSourceName, setDataSourceName] = useState('')
  if (props.selectedBorehole !== undefined) {
    DataList.getBoreholeSourceById(props.selectedBorehole?.DatasourceId, tokenSelector)
      .then((boreholeSource: BoreholeSource) => {
        setDataSourceName(boreholeSource.ShortName)
      })
      .catch(err => {
        console.error(err)
      })
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={3}>
          <span className={classes.title}><FormattedMessage id='borehole.info.number' /></span>
        </Grid>
        <Grid item xs={9}>
          {props.selectedBorehole?.BoreholeNumber}<br />
        </Grid>
        <Grid item xs={3}>
          <span className={classes.title}><FormattedMessage id='borehole.info.id' /></span>
        </Grid>
        <Grid item xs={9}>
          {props.selectedBorehole?.BoreholeId}<br />
        </Grid>
        <Grid item xs={3}>
          <span className={classes.title}><FormattedMessage id='borehole.info.source' /></span>
        </Grid>
        <Grid item xs={9}>
          {dataSourceName}<br />
        </Grid>
        <Grid item xs={3}>
          <span className={classes.title}><FormattedMessage id='borehole.info.coordinates' /></span>
        </Grid>
        <Grid item xs={9}>
          {props.selectedBorehole?.X}, {props.selectedBorehole?.Y}<br />
        </Grid>
        <Grid item xs={3}>
          <span className={classes.title}><FormattedMessage id='borehole.info.address' /></span>
        </Grid>
        <Grid item xs={9}>
          {props.postalAddress?.betegnelse}
        </Grid>
      </Grid>
    </div>
  )
}
